<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div slot="title" class="dialog-title">{{ $t('page.users.trackingDialog.title') }}</div>
    
    <el-form :model="form" :rules="rules" ref="trackingForm" label-width="100px">
      <el-form-item :label="$t('page.users.trackingDialog.company') + '：'" prop="company" required>
        <el-input 
          v-model="form.company" 
          :placeholder="$t('page.users.trackingDialog.companyPlaceholder')"
          maxlength="50"
        ></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('page.users.trackingDialog.trackingNumber') + '：'" prop="trackingNumber" required>
        <el-input 
          v-model="form.trackingNumber" 
          :placeholder="$t('page.users.trackingDialog.trackingNumberPlaceholder')"
          maxlength="50"
        ></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('page.users.trackingDialog.remark') + '：'">
        <el-input
          type="textarea"
          v-model="form.remark"
          :placeholder="$t('page.users.trackingDialog.remarkPlaceholder')"
          :rows="4"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('page.users.trackingDialog.uploadLabel') + '：'">
        <div class="upload-tip">{{ $t('page.users.trackingDialog.uploadTip') }}</div>
        <upload ref="uploadComponent" @picList="picList" :maxlength="3" :limitNum="3" />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="cancel-btn">{{ $t('page.users.trackingDialog.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit" class="submit-btn">{{ $t('page.users.trackingDialog.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import upload from '@/components/upload'

export default {
  name: 'TrackingDialog',
  components: {
    upload
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    refundId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        company: '',
        trackingNumber: '',
        remark: '',
        images: []
      },
      rules: {
        company: [
          { required: true, message: this.$t('page.users.trackingDialog.validateCompany'), trigger: 'blur' }
        ],
        trackingNumber: [
          { required: true, message: this.$t('page.users.trackingDialog.validateTrackingNumber'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.$nextTick(() => {
          this.resetForm()
        })
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    picList(images) {
      this.form.images = images
      console.log(images, 'images')
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    resetForm() {
      this.$refs.trackingForm && this.$refs.trackingForm.resetFields()
      this.form = {
        company: '',
        trackingNumber: '',
        remark: '',
        images: []
      }
      this.$refs.uploadComponent && this.$refs.uploadComponent.clearFiles()
    },
    handleSubmit() {
      this.$refs.trackingForm.validate((valid) => {
        if (valid) {
          const data = {
            id: this.refundId,
            express: this.form.company,
            express_no: this.form.trackingNumber,
            express_reason: this.form.remark,
            express_img: this.form.images.join(',')
          }
          
          this.$axios.post('/api/center/deliveryRefund', data).then(res => {
            this.$message.success(this.$t('page.users.trackingDialog.submitSuccess'))
            this.$emit('success')
            this.handleClose()
          }).catch(err => {
            this.$message.error(err.message || this.$t('page.users.trackingDialog.submitFailed'))
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

::v-deep .el-dialog__header {
  padding: 20px 20px 15px;
  border-bottom: 1px solid #EAEAEA;
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
}

::v-deep .el-dialog__footer {
  padding: 15px 20px 20px;
  border-top: 1px solid #EAEAEA;
}

::v-deep .el-form-item__label {
  color: #333;
  font-size: 14px;
  &::before {
    color: #E93323;
  }
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 4px;
  &:focus {
    border-color: #E93323;
  }
}

.upload-tip {
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}

.dialog-footer {
  text-align: center;
  
  .cancel-btn {
    width: 120px;
    border: 1px solid #DCDFE6;
    color: #606266;
    background: #fff;
    
    &:hover {
      border-color: #E93323;
      color: #E93323;
    }
  }
  
  .submit-btn {
    width: 120px;
    background-color: #E93323;
    border-color: #E93323;
    
    &:hover {
      background-color: #d42918;
      border-color: #d42918;
    }
  }
}
</style>
